export const searchBarHeight = 60;
export const wideBreakpoint = 1400;
export const sideBarWidth = 400;
export const sideBarWidthSmall = 250;
export const stickyPositionBelowJobTabs = 55;
export const skBlack = '#1c1c1c';
export const certsyPurple = '#4c459c';
